
// import slugify from "slugify";

// export const convertApiToNavData = (apiResponse, t = (k) => k, language = "tr") => {
//   if (!apiResponse?.docSearchList) return [];

//   const root = {
//     id: "root",
//     title: t("İÇİNDEKİLER"),
//     childs: [],
//   };

//   const findOrCreateNode = (parent, title) => {
//     let node = parent.childs.find((c) => c.title === title);
//     if (!node) {
//       node = {
//         id: slugify(title, { lower: true, strict: true }),
//         title,
//         childs: [],
//       };
//       parent.childs.push(node);
//     }
//     return node;
//   };

//   apiResponse.docSearchList.forEach((group) => {
//     const pathSegments = (group.groupLabelPath || "")
//       .split("/")
//       .filter(Boolean)
//       .map((seg) => t(seg.trim()));

//     let currentNode = root;
//     for (const segment of pathSegments) {
//       currentNode = findOrCreateNode(currentNode, segment);
//     }

//     (group.docList || []).forEach((doc) => {
//       const rawTitle = doc?.description?.subject?.trim() ?? t("Bilinmeyen Başlık");
//       const title = t(rawTitle);

//       currentNode.childs.push({
//         id: `${group.groupCode}-${doc?.id || "unknown"}`,
//         title,
//         uuid: doc.uuid,
//       });
//     });
//   });

//   return [root];
// };


// export const convertApiToNavData = (apiResponse, t = (k) => k, language = "tr", search = "") => {
//   if (!apiResponse) return [];

//   // 3 parametreli licenseDocInfo varsa docSearchList formatına çevir
//   if (apiResponse?.licenseDocInfo?.docUuid) {
//     const title = t("Doküman");
//     apiResponse.docSearchList = [
//       {
//         groupCode: "docinfo",
//         groupLabelPath: "",
//         docList: [
//           {
//             uuid: apiResponse.licenseDocInfo.docUuid,
//             description: { subject: title },
//           },
//         ],
//       },
//     ];
//     console.log("Converted 3-param API to docSearchList:", apiResponse.docSearchList);
//   }

//   if (!apiResponse?.docSearchList || apiResponse.docSearchList.length === 0) {
//     return [];
//   }

//   const root = {
//     id: "root",
//     title: t("İÇİNDEKİLER"),
//     childs: [],
//   };

//   const findOrCreateNode = (parent, title) => {
//     let node = parent.childs.find((c) => c.title === title);
//     if (!node) {
//       node = {
//         id: slugify(title, { lower: true, strict: true }),
//         title,
//         childs: [],
//       };
//       parent.childs.push(node);
//     }
//     return node;
//   };

//   const normalizedSearch = search.toLowerCase();

//   apiResponse.docSearchList.forEach((group) => {
//     const pathSegments = (group.groupLabelPath || "")
//       .split("/")
//       .filter(Boolean)
//       .map((seg) => t(seg.trim()));

//     let currentNode = root;
//     for (const segment of pathSegments) {
//       currentNode = findOrCreateNode(currentNode, segment);
//     }

//     (group.docList || []).forEach((doc) => {
//       const rawTitle = doc?.description?.subject?.trim() ?? t("Bilinmeyen Başlık");
//       const title = t(rawTitle);

//       if (!normalizedSearch || title.toLowerCase().includes(normalizedSearch)) {
//         currentNode.childs.push({
//           id: `${group.groupCode}-${doc?.id || "unknown"}`,
//           title,
//           uuid: doc.uuid,
//         });
//       }
//     });
//   });

//   console.log("Final converted navData:", [root]);
//   return [root];
// };

import slugify from "slugify";

const normalizeString = (str) => {
  if (!str) return "";
  return str
    .normalize("NFD") // aksanları ayır
    .replace(/[\u0300-\u036f]/g, "") // aksanları kaldır
    .replace(/£/g, "E") // özel karakter eşleme örneği
    .toLowerCase();
};


export const convertApiToNavData = (
  apiResponse,
  t = (k) => k,
  language = "tr",
  search = ""
) => {
  if (!apiResponse) return [];

  // 3 parametreli licenseDocInfo varsa docSearchList formatına çevir
  if (apiResponse?.licenseDocInfo?.docUuid) {
    const title =
      apiResponse.licenseDocInfo.licenseProductName ||
      t("Doküman");

    apiResponse.docSearchList = [
      {
        groupCode: "docinfo",
        groupLabelPath: "",
        docList: [
          {
            uuid: apiResponse.licenseDocInfo.docUuid,
            description: {
              subject: `${title} - V${apiResponse.licenseDocInfo.licenseCurrentVersion || ""}`,
            },
          },
        ],
      },
    ];
    console.log(
      "Converted 3-param API to docSearchList:",
      apiResponse.docSearchList
    );
  }

  if (!apiResponse?.docSearchList || apiResponse.docSearchList.length === 0) {
    return [];
  }

  const root = {
    id: "root",
    title: t("İÇİNDEKİLER"),
    childs: [],
  };

  const findOrCreateNode = (parent, title) => {
    let node = parent.childs.find((c) => c.title === title);
    if (!node) {
      node = {
        id: slugify(title, { lower: true, strict: true }),
        title,
        childs: [],
      };
      parent.childs.push(node);
    }
    return node;
  };

  const normalizedSearch = search.toLowerCase();

  apiResponse.docSearchList.forEach((group) => {
    const pathSegments = (group.groupLabelPath || "")
      .split("/")
      .filter(Boolean)
      .map((seg) => t(seg.trim()));

    let currentNode = root;
    for (const segment of pathSegments) {
      currentNode = findOrCreateNode(currentNode, segment);
    }

    (group.docList || []).forEach((doc) => {
      const rawTitle =
        doc?.description?.subject?.trim() ?? t("Bilinmeyen Başlık");
      const title = t(rawTitle);
      const keyword = doc?.description?.keyword || "";

      if (
        !normalizedSearch ||
        normalizeString(title).includes(normalizedSearch) ||
        normalizeString(keyword).includes(normalizedSearch)
      ) {
        currentNode.childs.push({
          id: `${group.groupCode}-${doc?.uuid || "unknown"}`, // id yerine uuid
          title,
          uuid: doc.uuid,
          keyword, // burası eklendi
        });
      }
    });

  });

  console.log("Final converted navData:", [root]);
  return [root];
};


